import React, { useLayoutEffect } from 'react';
import PropTypes from 'prop-types';
import Immutable from 'immutable';
import { connect } from 'react-redux';
import { DEFAULT_PAGE_SIZE } from '../../../../config/constants';
import ModuleList from '../../../layout/ModuleList';
import { breadcrumbsPropTypes } from '../../../common/resource/proptypes/CommonPropTypes';
import {
  clearPricingProfileDateRanges,
  getPricingProfileDateRanges,
} from '../../../../actions/sales/PricingProfileDateRange';
import {
  NEW_PRICING_PROFILE_DATE_RANGE_PATH,
  PRICING_PROFILE_DATE_RANGE_PATH,
} from '../../../../config/paths';
import { PRICING_PROFILE_DATE_RANGE_COLUMNS } from '../../../../config/columns';
import ClonePricingProfileDateRangeButton from './ClonePricingProfileDateRangeButton';

export const PricingProfileDateRanges = ({
  breadcrumbs,
  pricingProfileDateRanges,
  loading,
  dispatchGetPricingProfileDateRanges,
  dispatchClearPricingProfileDateRanges,
}) => {
  useLayoutEffect(() => () => dispatchClearPricingProfileDateRanges(), []);

  const data = pricingProfileDateRanges.get('content') || [];
  const pages = pricingProfileDateRanges.get('totalPages') || null;
  const defaultPageSize =
    pricingProfileDateRanges.get('size') || DEFAULT_PAGE_SIZE;

  return (
    <ModuleList
      title="Rango de Fechas para Perfiles de Precio"
      breadcrumbs={breadcrumbs}
      buttonPath={NEW_PRICING_PROFILE_DATE_RANGE_PATH}
      extraButtons={<ClonePricingProfileDateRangeButton />}
      tableStructure={{
        columns: PRICING_PROFILE_DATE_RANGE_COLUMNS,
        data,
        pages,
        defaultPageSize,
        filterable: true,
        fetchData: dispatchGetPricingProfileDateRanges,
        modelPath: PRICING_PROFILE_DATE_RANGE_PATH,
        loading,
        navigateToModelOnRowClick: true,
      }}
    />
  );
};

const mapDispatchToProps = {
  dispatchGetPricingProfileDateRanges: getPricingProfileDateRanges,
  dispatchClearPricingProfileDateRanges: clearPricingProfileDateRanges,
};

const mapStateToProps = ({ SalesUnit }) => ({
  breadcrumbs: [
    ...SalesUnit.UnitHome.get('breadcrumbs'),
    {
      text: 'Rango de Fechas para Perfiles de Precio',
      href: PRICING_PROFILE_DATE_RANGE_PATH,
    },
  ],
  pricingProfileDateRanges: SalesUnit.PricingProfileDateRange.getIn([
    'all',
    'content',
  ]),
  loading: SalesUnit.PricingProfileDateRange.getIn(['all', 'loading']),
});

PricingProfileDateRanges.propTypes = {
  breadcrumbs: breadcrumbsPropTypes.isRequired,
  pricingProfileDateRanges: PropTypes.instanceOf(Immutable.Map),
  loading: PropTypes.bool,
  dispatchGetPricingProfileDateRanges: PropTypes.func.isRequired,
  dispatchClearPricingProfileDateRanges: PropTypes.func.isRequired,
};

PricingProfileDateRanges.defaultProps = {
  pricingProfileDateRanges: null,
  loading: false,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(PricingProfileDateRanges);
